import React, { useMemo, useState, useEffect } from "react";
import { Button } from "../Button";
import TextInput from "../TextInput";
import { filterUserInput, getParentQueryParams, getDocumentQueryParams } from './helpers';
import { postHeightToParent } from '../common-helpers';
import { useScript } from "./../useScript";
import './ticker.css';

export const Ticker: React.FC = () => {
  const parentQuery = getParentQueryParams();// parent document, when ticker is embedded with iframe
  const docQueryParams = getDocumentQueryParams();
  const tickerFromQuery = parentQuery.ticker || docQueryParams.ticker || "";
  const lookUpFromQuery = docQueryParams.lookup === "off" && (parentQuery.ticker !== "" || docQueryParams.ticker !== "") ? false : true;
  const [ ticker, setTicker ] = useState<string>('');
  const [ userInput, setUserInput ] = useState<string>('');
  const [ isSearchable, setIsSearchable ] = useState<boolean>(lookUpFromQuery);
  const [ redirect, setRedirect ] = useState<string>('');
	const [scriptLoaded, scriptError] = useScript("https://s3.tradingview.com/tv.js", false);

  useMemo(() => {
    //validate ticker value from query if given
    if (tickerFromQuery !== "") {
      const [ validatedTickerValue, redirectLink ] = filterUserInput(tickerFromQuery);
      if (redirectLink !== "") {
        setRedirect(redirectLink);
        setIsSearchable(true);
      }
      setTicker(validatedTickerValue);
      setUserInput(validatedTickerValue);
    }
  }, [tickerFromQuery]);

	useEffect(() => {
		if (!scriptLoaded) return;
	}, [scriptLoaded, scriptError]);

  useEffect(() => {
    const widgetParams = {
      "autosize": true,
      "height": 610,
      "symbol": ticker,
      "interval": "1",
      "timezone": "America/New_York",
      "theme": "light",
      "style": "3",
      "locale": "en",
      "toolbar_bg": "#f1f3f6",
      "enable_publishing": false,
      "withdateranges": true,
      "save_image": false,
      "details": true,
      "hotlist": true,
      "calendar": true,
      "container_id": "tradingview_701d6"
    };

    if (scriptLoaded && !scriptError) {
      let script = document.createElement("script");
      script.innerHTML = `new TradingView.widget(${JSON.stringify(widgetParams)});`;
      document.getElementById("widget")?.appendChild(script);
    }
  }, [ticker, scriptLoaded, scriptError]);

  const validateUserInput = () => {
    let [ filteredTicker, redirectLink ] = filterUserInput(userInput);
    (redirectLink !== "") ? setRedirect(redirectLink) : setTicker(filteredTicker);
  };

  useEffect(() => {
    postHeightToParent(document.body.scrollHeight);
  }, [isSearchable, redirect]);

	return (
    <div className="ticker-widget">
      { isSearchable && (
        <>
          <h2>Ticker Lookup</h2>
          <div className="ticker-search">
            <form className="kip-market-search">
              <TextInput
                id="ticker_search"
                name="ticker-search"
                fieldClass="ticker-input"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  setUserInput((e.target.value).toUpperCase());
                  setRedirect('');
                }}
                value={userInput}
                data-testid="ticker-input"
              />
              <Button
                label="Get Quote"
                className="primary-button ticker-btn"
                onClickHandler={ () => validateUserInput() }
                data-testid="ticker-load"
              />
            </form>
          </div>
        </>
      )}
      { redirect ? (
        <p className="ticker-redirect">
          {`${ userInput } chart is not available.`} <br/>
          <a href={ redirect } rel="noreferrer" target="_blank">{`Look up ${ userInput } chart on Yahoo Finance page`}</a>.
        </p>
      ) : (
        <div className="ticker-container">
          <div className="tradingview-widget-container"  style={{height: "100%"}}>
            <div id="tradingview_701d6" style={{height: "100%"}}></div>
              <div className="tradingview-widget-copyright">
                <a href={`https://www.tradingview.com/symbols/${ ticker }/`} rel="noreferrer" target="_blank">
                <span className="blue-text">{ ticker } Chart</span></a> by TradingView
                <div id="widget"></div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
